import { WSForm, WSInputNumber } from "@wingspanhq/fe-component-library";
import React from "react";
import { IDynamicFieldProps } from "../../types";
import {
  fieldLabel,
  isFieldRequired,
  maxValueFromRules,
  minValueFromRules
} from "../../utils/fieldRules";

export const DynamicFieldNumber: React.FC<IDynamicFieldProps> = ({
  field,
  name,
  disabled,
  defaultValue
}) => (
  <WSForm.Field
    name={name}
    defaultValue={defaultValue}
    label={fieldLabel(field)}
    description={field.description ?? field.ui?.helpText}
    component={WSInputNumber}
    componentProps={{
      placeholder: field.ui?.placeholder ?? field.label,
      disabled,
      required: isFieldRequired(field),
      min: minValueFromRules(field.validation.rules),
      max: maxValueFromRules(field.validation.rules),
      suffix: field.ui?.suffix ?? (field.type === "Percent" ? "%" : undefined)
    }}
  />
);
